export function hasDisabledFeatureFlag(flags, targetFlags) {
  return (targetFlags || []).some((flag) => !flags[flag]);
}
